import { ScreenType, useScreenType } from "@redotech/react-util/screen";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { RedoTagInputField } from "@redotech/redo-web/arbiter-components/input/redo-tag-input-field";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export const DiscountInputWithButton = memo(function DiscountInputWithButton({
  label,
  description,
  discountCodes,
  newDiscountCode,
  enabled,
  onChangeDiscountCodes,
  onChangeNewDiscountCode,
}: {
  label: string;
  description: string;
  discountCodes: string[];
  newDiscountCode: string;
  enabled: boolean;
  onChangeDiscountCodes: (codes: string[]) => void;
  onChangeNewDiscountCode: (code: string) => void;
}) {
  const handleAddDiscount = () => {
    if (newDiscountCode.trim()) {
      onChangeDiscountCodes([...discountCodes, newDiscountCode.trim()]);
      onChangeNewDiscountCode("");
    }
  };

  const isMobile = useScreenType() === ScreenType.MOBILE;

  return (
    <Flex data-testid="discount-input-container" dir="column" gap="sm" w="full">
      <Text fontSize="xs" textColor="tertiary">
        {label}
      </Text>
      <Flex dir="row" gap="sm" w="full">
        <Flex basis="0" grow={1} shrink={1} w="full">
          <RedoTagInputField
            delimiters={[]}
            inputValue={newDiscountCode}
            setInputValue={onChangeNewDiscountCode}
            setTags={onChangeDiscountCodes}
            size={isMobile ? "md" : "sm"}
            state={enabled ? "default" : "disabled"}
            tags={discountCodes.map((code) => ({ text: code }))}
          />
        </Flex>
        <Flex grow={isMobile ? 0 : undefined} shrink={0}>
          <RedoButton
            dataTestId="apply-discount-button"
            disabled={!enabled || !newDiscountCode.trim()}
            hierarchy="secondary"
            onClick={handleAddDiscount}
            size={isMobile ? "md" : "sm"}
            text="Apply"
          />
        </Flex>
      </Flex>
      <Text fontSize="xs" textColor="tertiary">
        {description}
      </Text>
    </Flex>
  );
});
